import { useEffect } from 'react';
import withRouter from '@/components/withRouter';
import { isMobile } from 'react-device-detect';
import GrtLoading from '@/components/GrtLoading/GRTLoading';
const ShareSameLink = (props) => {
    let pathName = props.searchParams.get('path'),
        mobile = props.searchParams.get('mobile'),
        web = props.searchParams.get('web');
    //判断pc还是移动端，跳转到对应页面
    const handleHref = () => {
        let { protocol, host } = window.location,
            href = null,
            path = `${protocol}//${host}`;

        if (isMobile) {
            href = mobile ? `${path}/mobile/${mobile}` : `${path}/mobile/${pathName}`;
        } else {
            href = web ? `${path}/web/${web}` : `${path}/web/${pathName}`;
        }

        window.location.replace(href);
    };

    useEffect(() => {
        if (pathName || mobile || web) {
            handleHref();
        }
    }, [pathName, mobile, web]);

    return (
        <div>
            <GrtLoading></GrtLoading>
        </div>
    );
};
export default withRouter(ShareSameLink);
